var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_16249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80629 7.75844C9.53251 6.76746 9.85778 5.53881 9.71702 4.3183C9.57626 3.0978 8.97985 1.97545 8.04711 1.17579C7.11438 0.376132 5.9141 -0.0418557 4.68642 0.00544912C3.45873 0.052754 2.29418 0.561863 1.42574 1.43092C0.557302 2.29998 0.0490263 3.4649 0.00259989 4.69262C-0.0438265 5.92033 0.37502 7.12031 1.17534 8.05247C1.97567 8.98464 3.09845 9.58024 4.31905 9.72013C5.53966 9.86002 6.76807 9.53387 7.75854 8.80694H7.75779C7.78029 8.83694 7.80429 8.86544 7.83129 8.89319L10.7188 11.7807C10.8594 11.9214 11.0502 12.0005 11.2491 12.0006C11.4481 12.0007 11.6389 11.9217 11.7797 11.7811C11.9204 11.6404 11.9995 11.4497 11.9996 11.2507C11.9996 11.0518 11.9207 10.8609 11.78 10.7202L8.89254 7.83269C8.86572 7.80555 8.83689 7.78048 8.80629 7.75769V7.75844ZM8.99979 4.87544C8.99979 5.41714 8.89309 5.95354 8.68579 6.45401C8.47849 6.95448 8.17465 7.40922 7.7916 7.79226C7.40856 8.1753 6.95383 8.47914 6.45336 8.68645C5.95289 8.89375 5.41649 9.00044 4.87479 9.00044C4.33309 9.00044 3.79669 8.89375 3.29622 8.68645C2.79575 8.47914 2.34101 8.1753 1.95797 7.79226C1.57493 7.40922 1.27109 6.95448 1.06379 6.45401C0.856485 5.95354 0.749788 5.41714 0.749788 4.87544C0.749788 3.78142 1.18439 2.73221 1.95797 1.95863C2.73156 1.18504 3.78077 0.750442 4.87479 0.750442C5.96881 0.750442 7.01802 1.18504 7.7916 1.95863C8.56519 2.73221 8.99979 3.78142 8.99979 4.87544Z",
    fill: "#8C8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_16249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGray);
export default __webpack_public_path__ + "static/media/searchGray.6b9e8af432db6edaa33c8d732296db5d.svg";
export { ForwardRef as ReactComponent };